import { Api } from '../base/Api';
import { Injectable } from '@angular/core';
import { TownhouseCalendar } from 'src/app/models/TownhouseCalendar';


@Injectable({
    providedIn: 'root'
})
export class TownhouseCalendarApi extends Api<TownhouseCalendar> {}
